export default __webpack_public_path__ + "static/media/icon-close-white.4ec7c37a.svg";